import React from 'react';
import {Checkbox, FormControlLabel, makeStyles} from '@material-ui/core';
import propTypes from 'prop-types';
import DefaultRow from './default-row';
import ImageThumbnailsRow from './image-thumbnails-row';
import {assetsTableStylesObject, convertCamelCaseToWords, formatTimeStamp} from '../../helpers/tools';

const useStyles = makeStyles(() => ({
  ...assetsTableStylesObject,
  boolean_label: {marginLeft: 10},
}));

const RowContent = ({echostarId, rowContent, skipGenres = false, isUpdating = false, ruidsToDelete, onDeleteDp}) => {
  const classes = useStyles();

  const renderStringFields = (data, incomingRowContent) => {
    const timeStampProperties = ['originalAirDate'];
    const assureString = value => `${value}`;

    return data.map((item, i) => {
      if (item.type === 'boolean' || !incomingRowContent[item.name]) return null;

      if (
        assureString(incomingRowContent[item.name]).length &&
        assureString(incomingRowContent[item.name]).trim().length
      ) {
        return (
          <div className={classes.rowDiv} key={i}>
            <h4 className={isUpdating ? classes.rowHeaderDisabled : classes.rowHeader}>
              {convertCamelCaseToWords(item.name)}
            </h4>
            <span className={isUpdating ? classes.rowCellDisabled : classes.rowCell}>
              {timeStampProperties.includes(item.name)
                ? formatTimeStamp(incomingRowContent[item.name], {year: 'numeric', month: 'long', day: 'numeric'})
                : incomingRowContent[item.name]}
            </span>
          </div>
        );
      }
      return null;
    });
  };

  const renderBooleanFields = (data, incomingRowContent) => (
    <div className={classes.rowDiv}>
      <h4 className={isUpdating ? classes.rowHeaderDisabled : classes.rowHeader}>Options</h4>
      {data.map((item, i) => {
        if (item?.type === 'boolean' && typeof incomingRowContent[item.name] === 'boolean') {
          return (
            <FormControlLabel
              className={classes.boolean_label}
              control={<Checkbox checked={incomingRowContent[item.name]} name={item.name} />}
              key={i}
              label={item.display}
            />
          );
        }
        return null;
      })}
    </div>
  );

  if (echostarId && rowContent) {
    const actors = rowContent?.actors;
    const aliases = rowContent?.aliases;
    const dataPackages = rowContent?.dataPackages;
    const directors = rowContent?.directors;
    const genres = rowContent?.genres;
    const pictures = rowContent?.pictures;
    const reviews = rowContent?.reviews;
    const series = rowContent?.series;
    const otherFieldsList = [
      {name: 'category', type: 'string'},
      {name: 'description', type: 'string'},
      {name: 'shortDescription', type: 'string'},
      {name: 'echostar2Id', type: 'string'},
      {name: 'guid', type: 'string'},
      {name: 'expired', type: 'boolean', display: 'Expired'},
      {name: 'isRecommended', type: 'boolean', display: 'Is Recommended'},
      {name: 'mpaa', type: 'string'},
      {name: 'newToDISH', type: 'boolean', display: 'New to Dish'},
      {name: 'numberOfDownloads', type: 'string'},
      {name: 'originalAirDate', type: 'string'},
      {name: 'theaterRelease', type: 'boolean', display: 'Theater Release'},
      {name: 'year', type: 'string'},
    ];
    const packages = rowContent && rowContent.dataPackages ? rowContent.dataPackages : [];
    const revisedPackages = packages.map(p => {
      const {dataPackageId, startDate, endDate, format, networkName, resolution, runtime, vodType} = p;
      const products = p?.products.map(r => r?.type).join(',');
      const {amount} = p.products[0];
      const {productId} = p.products[0].productId === '-1' || p.products[0].productId === '-2' ? '' : p.products[0];

      return {
        dataPackageId,
        format,
        networkName,
        startDate,
        endDate,
        products,
        resolution,
        runtime,
        vodType,
        amount,
        productId,
      };
    });

    return (
      <tr>
        <td colSpan={4}>
          <ImageThumbnailsRow picturesToRender={pictures} />
          {!skipGenres && !isUpdating && (
            <DefaultRow asset={rowContent} data={genres} header="Genres" isUpdating={isUpdating} row="strValue" />
          )}
          {!skipGenres && !isUpdating && (
            <DefaultRow asset={rowContent} data={aliases} header="Aliases" isUpdating={isUpdating} row="aliasName" />
          )}

          {renderStringFields(
            skipGenres ? otherFieldsList.filter(o => o.name !== 'category') : otherFieldsList,
            rowContent
          )}
          {renderBooleanFields(otherFieldsList, rowContent)}

          <DefaultRow
            asset={rowContent}
            data={dataPackages}
            header="Data Packages"
            isUpdating={isUpdating}
            packages={revisedPackages || []}
            row="dataPackageId"
            ruidsToDelete={ruidsToDelete}
            onDeleteDP={onDeleteDp}
          />
          <DefaultRow asset={rowContent} data={series} header="Series" isUpdating={isUpdating} row="name" />
          <DefaultRow
            asset={rowContent}
            data={directors?.length ? directors.join(',') : []}
            header="Directors"
            isUpdating={isUpdating}
            row="name"
          />
          <DefaultRow
            asset={rowContent}
            data={actors?.length ? actors.join(',') : []}
            header="Names"
            isUpdating={isUpdating}
            row="name"
          />
          <DefaultRow asset={rowContent} data={reviews} header="Review" isUpdating={isUpdating} row="name" />
        </td>
      </tr>
    );
  }
  return null;
};

export default RowContent;

RowContent.propTypes = {
  echostarId: propTypes.number,
  isUpdating: propTypes.bool,
  onDeleteDp: propTypes.func,
  rowContent: propTypes.object,
  ruidsToDelete: propTypes.array,
  skipGenres: propTypes.bool,
};
